import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "../components/protected-route";

const SignInForm = lazy(() => import("../views/Auth/SignInForm"));
const SignUpForm = lazy(() => import("../views/Auth/SignUpForm"));
const SignOutPage = lazy(() => import("../views/Auth/SignOutPage"));
const DashboardPage = lazy(() => import("../views/StatusBoard/dashboard"));

const AppRouter: React.FC = () => (
  <Suspense fallback={<div className="spinner-border text-primary" />}>
    <Routes>
      <Route path="/signin" element={<SignInForm />} />
      <Route path="/signup" element={<SignUpForm />} />
      <Route path="/signout" element={<SignOutPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Navigate to="/dashboard" replace />
          </ProtectedRoute>
        }
      />
    </Routes>
  </Suspense>
);

export default AppRouter;
